const moment = require('moment');
const { default: AggConstants } = require('../../constants/AggConstants');
const { default: TipoAtributo } = require('../../constants/TipoAtributo');
const { SPLIT_CHAR_SPECIAL } = require('../../constants/Split');
const { default: SystemConstants } = require('../../common/SystemConstants');
const FiltroConstants = require('../../constants/FiltroConstants').default;
const Atributos = require('../../common/Atributos');
module.exports = {
    cubo: 'cubo_fichas',
    title: SystemConstants.Strings.paginas.dadosExposicaoVitimaHumanaExposicao,
    primeiraConsultaAutomatica: true,
    atributosSelecionados: [
        Atributos.F_CIRCUNSTANCIA_EXPOSICAO_DESCRICAO_ASSOC,
        Atributos.F_VIA_EXPOSICAO_DESCRICAO_ASSOC,
        // Atributos.QNT, // Sempre colocar o último atributo como métrica.
    ],
    nextPage: SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_ENCERRAMENTO,
    backPage: SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA,
    charts: [
        {
            title: 'CIRCUNSTÂNCIA DA EXPOSIÇÃO',
            description: 'Circunstância da Exposição.',
            type: 'Pivottable',
            headers: ['Circunstância da Exposição', 'Quantidade'],
            selectDimensions: [Atributos.F_CIRCUNSTANCIA_EXPOSICAO_DESCRICAO_ASSOC, Atributos.QNT],
            rows: ['Circunstância da Exposição'],
            rowOrder: 'value_z_to_a',
            aggregatorName: 'Sum as Fraction of Total',
            vals: ['Quantidade'],
            aggregatorList: [
                {
                    vals: ['Quantidade'],
                    aggTitle: 'Quantidade',
                    aggregatorName: 'Integer Sum',
                },
                {
                    vals: ['Quantidade'],
                    aggTitle: '%',
                    aggregatorName: 'Sum as Fraction of Total',
                },
            ],
            cols: [],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_CIRCUNSTANCIA_EXPOSICAO_DESCRICAO_ASSOC],
                    transformation: (value) => {
                        if (value.startsWith('Erro de Medicação')) {
                            return 'Erro de Medicação';
                        }
                        switch (value) {
                            case 'Não preenchido':
                            case 'Ignorado':
                                return 'Ignorada';
                            default:
                                return value;
                        }
                    },
                },
            ],
        },
        {
            title: 'VIA DA EXPOSIÇÃO',
            description: 'Via da Exposição.',
            type: 'Pivottable',
            headers: ['Via da Exposição', 'Quantidade'],
            selectDimensions: [Atributos.F_VIA_EXPOSICAO_DESCRICAO_ASSOC, Atributos.QNT],
            rows: ['Via da Exposição'],
            rowOrder: 'value_z_to_a',
            aggregatorName: 'Sum as Fraction of Total',
            vals: ['Quantidade'],
            aggregatorList: [
                {
                    vals: ['Quantidade'],
                    aggTitle: 'Quantidade',
                    aggregatorName: 'Integer Sum',
                },
                {
                    vals: ['Quantidade'],
                    aggTitle: '%',
                    aggregatorName: 'Sum as Fraction of Total',
                },
            ],
            cols: [],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_VIA_EXPOSICAO_DESCRICAO_ASSOC],
                    transformation: (value) => {
                        if (value.startsWith('Parenteral')) {
                            return 'Parenteral';
                        }
                        switch (value) {
                            case 'Não preenchido':
                            case 'Ignorado':
                                return 'Ignorada';
                            default:
                                return value;
                        }
                    },
                },
            ],
        },
    ],
    metaAtributos: [
        {
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            grupo: 'Nome do centro',
            rotulo: 'Nome do centro',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            grupo: 'Ano de atendimento',
            rotulo: 'Ano de atendimento',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            grupo: 'Tipo de Ficha',
            rotulo: 'Tipo de Ficha',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            grupo: 'UF Solicitante',
            rotulo: 'UF Solicitante',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.GRUPO,
            grupo: 'Grupo de agentes',
            rotulo: 'Grupo de agentes',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_PACIENTE_SEXO,
            grupo: 'Paciente: Sexo',
            rotulo: 'Paciente: Sexo',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_PACIENTE_FAIXA_ETARIA,
            grupo: 'Paciente: Faixa etária',
            rotulo: 'Paciente: Faixa etária',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO,
            grupo: 'Exposição: Circunstância',
            rotulo: 'Exposição: Circunstância',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ENCERRAMENTO_CLASS_GRAVI_DESCRICAO,
            grupo: 'Classificação de Gravidade Final',
            rotulo: 'Classificação de Gravidade Final',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.CIRCUNSTANCIA_DESCRICAO,
            grupo: 'Desfecho',
            rotulo: 'Desfecho',
            tipo: 'TEXTO',
        },
    ],
    preFiltrosServer: [
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            tipoComponente: 'IN_SELECT',
            valor: ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026'].join(FiltroConstants.SPLIT_VALUES),
        },
    ],
    filtros: [
        {
            key: 0,
            disabled: true,
            hidden: true,
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            rotulo: 'Tipo de ficha',
            tipoComponente: 'IN_SELECT',
            valor: 'Humana',
        },
        {
            key: 1,
            size: 2,
            disabled: true,
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            rotulo: 'Ano do atendimento',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 2,
            size: 2,
            disabled: false,
            atributo: Atributos.GRUPO,
            rotulo: 'Grupo de agentes',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 3,
            size: 2,
            disabled: false,
            atributo: Atributos.F_PACIENTE_SEXO,
            rotulo: 'Sexo',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 4,
            size: 2,
            disabled: false,
            atributo: Atributos.F_PACIENTE_FAIXA_ETARIA,
            rotulo: 'Faixa etária',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 5,
            size: 2,
            disabled: true,
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            rotulo: 'UF Solicitante',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 6,
            size: 2,
            disabled: false,
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            rotulo: 'Nome do centro',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 7,
            size: 2,
            disabled: false,
            atributo: Atributos.CIRCUNSTANCIA_DESCRICAO,
            rotulo: 'Circunstância',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 8,
            size: 2,
            disabled: false,
            atributo: Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO,
            rotulo: 'Desfecho',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
    ],
};
